import { render, staticRenderFns } from "./PredefinedResponses.vue?vue&type=template&id=298919ea&scoped=true"
import script from "./PredefinedResponses.vue?vue&type=script&lang=js"
export * from "./PredefinedResponses.vue?vue&type=script&lang=js"
import style0 from "./PredefinedResponses.vue?vue&type=style&index=0&id=298919ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298919ea",
  null
  
)

export default component.exports